import { toast } from 'react-toastify';

/**
 * Downloads a file from a URL (e.g. S3 presigned URL) by fetching as blob
 * and triggering a browser download. Handles expired/invalid links with user feedback.
 */
export const downloadFileFromUrl = async (
  url: string,
  filename: string,
): Promise<void> => {
  try {
    const response = await fetch(url);

    if (!response.ok) {
      const text = await response.text();
      const isExpired =
        text.includes('Request has expired') ||
        text.includes('AccessDenied') ||
        text.includes('<Code>AccessDenied</Code>');
      toast.error(
        isExpired
          ? 'This download link has expired. Please refresh the page and try again.'
          : 'Failed to download file. Please try again.',
        { position: 'bottom-left', autoClose: 5000 },
      );
      return;
    }

    const contentType = (
      response.headers.get('Content-Type') || ''
    ).toLowerCase();
    if (
      contentType.includes('application/xml') ||
      contentType.includes('text/xml') ||
      contentType.includes('text/html')
    ) {
      toast.error(
        'This download link has expired or is invalid. Please refresh the page and try again.',
        { position: 'bottom-left', autoClose: 5000 },
      );
      return;
    }

    const blob = await response.blob();
    const objectUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(objectUrl);
    document.body.removeChild(a);
  } catch (error) {
    console.error('Error downloading file:', error);
    toast.error('Failed to download file. Please try again.', {
      position: 'bottom-left',
      autoClose: 3000,
    });
  }
};
